import { render, staticRenderFns } from "./ProductBillOfMaterialList.vue?vue&type=template&id=0d4b6ebe"
import script from "./ProductBillOfMaterialList.vue?vue&type=script&lang=ts"
export * from "./ProductBillOfMaterialList.vue?vue&type=script&lang=ts"
import style0 from "./ProductBillOfMaterialList.vue?vue&type=style&index=0&id=0d4b6ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports